import styled from 'styled-components'

export const Spacer = styled.div<{ height?: string, width?: string }>`
height: ${props => props.height ?? props.theme.spacing.xLarge};
width: ${props => props.width ?? props.theme.spacing.xLarge};
`
